import {FormControl, FormHelperText, InputAdornment, Stack, Typography,Box} from '@mui/material'

import AppTextField from "@/components/AppTextField";
import RouteConstant from "@/constant/RouteConstant";
import React from "react";
import {useTranslation} from "react-i18next";
import {getUrlParams} from "@/utils/utils";
import AppLoadingButton from "@/components/mui/LoadingButton";
import {useBoolean, useRequest} from "ahooks";
import {useFormik} from "formik";
import FormItem from "@/components/FormItem.tsx";

import { PageTitle } from '@/styles/CommonSx'
import { addWithdrawAddress } from '@/services/user'
import {useNavigate} from "react-router-dom";
import PageBack from "@/components/PageBack";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader";

const AddAddaress = () => {
  const {t} = useTranslation();
  const paramVarietyCode = getUrlParams("variety_code");
  const paramcoin = getUrlParams("coin");
  const paramDisplayName = getUrlParams("display_name");
  const navigate = useNavigate();
  const validate = values => {
    const errors = {};
    if (!values.address) {
      errors.address = t("this_field_is_required")
    }
    // if (!isAddress(values.address)) {
    //   errors.address = 'Invalid address';
    // }
    return errors;
  }
  const formObj = useFormik({
    initialValues: {
      address: '',
      label: ''
    },
    // validationSchema,
    validate,
    validateOnBlur: true,
    validateOnChange: true,
    validateOnMount: true,
    onSubmit: () => {
      onAddAddress()
    },
  })

  const addWithdrawAddressReq = useRequest(async () => {
    const res = await addWithdrawAddress({
      varietyCode: paramVarietyCode,
      coin: paramcoin,
      withdrawAddress: formObj.values.address.trim(),
      remark: formObj.values.label
    })
    return res;
  }, { manual: true })

  const onAddAddress = () => {
    addWithdrawAddressReq.runAsync().then(res => {
      navigate(-1, {replace: true})
    })
  }

  return (<>
    <Stack  sx={{ width: '100%', height: '100%' }}>
      <SimpleHeader />
      <Box sx={{padding:'16px'}}><Typography sx={theme => ({...PageTitle(theme)})}>{t('add_address')}</Typography></Box>
      <Box sx={{padding:'16px'}}>
        <Stack direction="row" gap='10px' sx={{marginBottom:'20px'}}>
          <Typography
            sx={theme => {
              return {
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.tertiary,
                padding: '4px 8px'
              }
            }}

          >{paramVarietyCode.toUpperCase()}</Typography>
          <Typography
            sx={theme => {
              return {
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.tertiary,
                padding: '4px 8px'
              }
            }}
          >{paramDisplayName}</Typography>
        </Stack>
        <form autoComplete="off" onSubmit={formObj.handleSubmit}>
          <Stack sx={{ width: '100%' }}>
            <AppTextField
              label={t('address')}
              name="address"
              variant="outlined"
              value={formObj.values.address}
              onChange={formObj.handleChange}
              error={Boolean(formObj.touched.address && formObj.errors.address)}
              helperText={formObj.touched.address && formObj.errors.address}
              autoComplete="off"
              placeholder={t('address')}
              fullWidth
              sx={{ mb: 4 }}
            />
            <AppTextField
              label={t('address_label')}
              name="label"
              value={formObj.values.label}
              onChange={(e) => { formObj.setFieldValue('label', e.target.value); }}
              error={Boolean(formObj.touched.label && formObj.errors.label)}
              autoComplete="off"
              placeholder={t('address_label')}
              fullWidth
              sx={{ mb: 4 }}
            />
            <Box className={'fixed-button'}>
              <AppLoadingButton
                size={'large'}
                variant="contained" fullWidth loading={addWithdrawAddressReq.loading}
                type="submit">{t('save')}</AppLoadingButton>
            </Box>
          </Stack>
        </form>
      </Box>
    </Stack>
    {/*<TwoFAModal successCallback={() => { onAddAddress() }} open={twoFAModalShow} onClose={twoFAModalShowOperate.setFalse} />*/}

  </>)
}

export default AddAddaress